import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";
import {Giustificativi} from "@commons/mapping/Giustificativi";
import {StatusGiustificativoRecord} from "@commons/mapping/StatusGiustificativoRecord";
import {ObjectFactory} from "@commons/types";

export interface StatusRecord extends CentroDiCostoRecord { // todo implementare
    idTipo: 10,
}

export class StatusRecord {
    static factory: ObjectFactory<StatusRecord> = (json?) => {
        return {
            ...CentroDiCostoRecord.factory(json),
            idTipo: 10,
        };
    }
}